import { render, staticRenderFns } from "./LetrexForm.vue?vue&type=template&id=4b8dd0b1&scoped=true"
import script from "./LetrexForm.vue?vue&type=script&lang=js"
export * from "./LetrexForm.vue?vue&type=script&lang=js"
import style0 from "./LetrexForm.vue?vue&type=style&index=0&id=4b8dd0b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8dd0b1",
  null
  
)

export default component.exports